module.exports = __webpack_public_path__ + "static/media/5.b5c5cd81.png";